import { secureApi } from './secureApi';

/**
 * Guest guide API — company-wide content «دليل الضيف العام».
 * tasks/guest-guide-sections-and-print-sheet.md (G2 / G12).
 *
 * Backend: be/routes/guestGuideDefaultsRoutes.js (mounted at /api/v1/guest-guide-defaults).
 * Read: core staff. Write: admin + ops-manager (enforced by the server).
 * Saves are partial — send only the fields you change.
 */
const guestGuideApi = {
  getDefaults: async () => {
    const res = await secureApi.get('/api/v1/guest-guide-defaults');
    return res.data.defaults;
  },

  updateDefaults: async (changes) => {
    const res = await secureApi.put('/api/v1/guest-guide-defaults', changes, { preserveBackendError: true });
    return res.data.defaults;
  }
};

export default guestGuideApi;
